<template>
  <div style="">
      <div v-show="isRedemption" id="divRD" class="row">
      <div class="col">
        <q-list class="page">

            <q-item v-if="Redemption.length==0">
              <q-item-section class="q-pl-xs">
               {{$t("Redeem.nofundincart")}}
              </q-item-section>
            </q-item>
          
          <div class="row">
            <div class="col-12 q-px-md q-pt-md" v-bind:key="Red.index" v-for="Red in Redemption">
              <q-item-section class="q-pa-none" style="">
                <div class="row q-mb-sm">

                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" style="">
                      <div class="fieldStyle">
                        <b>{{$t("Redeem.fund")}}</b>
                        <div>{{ Red.FundName }}</div>
                      </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" style="" >
                    <div class="fieldStyle" >
                          <b>{{$t("Redeem.plan")}}</b>
                          <div>{{ Red.Plan }}</div>
                    </div>
                  </div>

                  
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" style="" >
                      <div class="fieldStyle">
                        <b>{{$t("Redeem.currency")}}</b>
                        <div>{{Red.FundCurrency}}</div>
                     </div>
                  </div>
                  
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" style="" >
                      <div class="fieldStyle" >
                          <b>{{$t("Redeem.redemptionunit")}}</b>
                          <div>{{Red.Units.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})|thousandSeparator}}</div>
                      </div>
                  </div>
                   
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" style="" >
                      <div class="fieldStyle" >
                          <b>{{$t("Redeem.expectedamount")}}</b>
                          <div>{{formatPrice(Red.ExpectedAmount)}}</div>
                      </div>
                  </div>
                </div>

              <div class="row text-right q-mb-md q-pr-sm" style="margin-top: auto;">
                <div class="col ">
                  <!-- <q-btn flat icon="delete" color="primary" round  @click="RemoveRedemption(Red.Id, Red.count)"/> -->
                  <q-btn outline class="" label="Remove" style="color: #ff6666;" @click="RemoveRedemption(Red.Id, Red.count)"/>
                </div>
              </div>

              </q-item-section>
              <q-separator style="margin: 0 0.75rem; width: auto;" v-if="Redemption.indexOf(Red) + 1 != Redemption.length"/>

              <!-- <div class="row q-px-sm">
                <div class="col-10 col-xs-12 col-sm-10 col-md-10">
                  <a class="text-grey-6">{{$t("Redeem.redemption")}}</a><br>
                  <a class="text-weight-bold">{{Red.FundName}}</a> -->
                  <!-- <q-input :label='$t("Redeem.redemption")' readonly :value="Red.FundName"/> -->
                <!--</div>
              </div> -->

              <!-- start "table" inside my cart -->
              
              <!-- <div class="row text-center q-px-sm">
                <div class="col-xs-12 col-sm-3 col-md-3 q-pa-sm" style="border:1px solid #A6A6A6">
                  <a class="text-grey-6">{{$t("Redeem.plan")}}</a><br>
                  <a>{{Red.Plan}}</a>
                </div>
                <div class="col-xs-12 col-sm-3 col-md-3 q-pa-sm" style="border:1px solid #A6A6A6">
                  <a class="text-grey-6">{{$t("Redeem.currency")}} {{$t("Redeem.redemptionunit")}}</a><br>
                  <a>{{Red.FundCurrency}}</a>
                </div> -->
                <!-- <div class="col" style="border:1px solid #A6A6A6">
                  <a class="text-grey-6">Bank Account No</a><br>
                  <a>{{Red.BankAccountNumber}}</a>
                </div> 
                <div class="col" style="border:1px solid #A6A6A6">
                  <a class="text-grey-6">Cut Off Time</a><br>
                  <a>{{GetSchemeRedeemCutoffTime(Red.FundID)}}</a>
                </div>-->
                <!--
                <div class="col-xs-12 col-sm-3 col-md-3 q-pa-sm" style="border:1px solid #A6A6A6">
                  <a class="text-grey-6"> {{$t("Redeem.redemptionunit")}}</a><br>
                  <a>{{Red.Units.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})|thousandSeparator}}</a>
                </div>
                
                <div class="col-xs-12 col-sm-3 col-md-3 q-pa-sm" style="border:1px solid #A6A6A6">
                  <a class="text-grey-6">{{$t("Redeem.expectedamount")}} (MYR)</a><br>
                  <a>{{formatPrice(Red.ExpectedAmount)}}</a>
                </div> -->
                <!-- 
                  <div class="col" style="border:1px solid #A6A6A6">
                  <a class="text-grey-6">Balance Units</a><br>
                  <a>{{formatts(Red.BalanceUnits)}}</a>
                </div> -->
              <!-- </div> -->
              
              
            </div>
            </div>
            <!-- end "table" -->
            
            <q-item class="q-px-md q-py-sm q-ma-md" style="border-radius: 0.5rem; background: #f5f5f5;">
                <q-item-section>
                  <div class="row">
                    <div class="text-caption">
                      <ol>
                        <b>{{$t("Notice.title")}}:</b>
                        <li class="q-pb-md">{{$t("Notice.info1")}}</li>
                        <li class="q-pb-md">{{$t("Notice.info5")}}</li>
                      </ol>
                    </div>
                  </div>
              </q-item-section>
            </q-item>
        </q-list>
      </div>
    </div>
   

    <!--Popup Edit Topup/New Modal-->
    <q-dialog persistent v-model="TopupModal" transition-show="rotate" transition-hide="rotate">
      <q-card>
        <q-card-section>
          <div class="text-h6 text-center">Edit Top Up</div>
        </q-card-section>

        <q-card-section>
          <FTB></FTB>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn label="Cancel" v-close-popup />
          <q-btn label="Complete" color="primary" @click="EditCart('Buy')" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <!--Popup Redeem / Switch Modal-->
    <q-dialog persistent v-model="SellModal" transition-show="rotate" transition-hide="rotate">
      <q-card>
        <q-card-section>
          <div class="text-h6 text-center">Edit Redemption/Switching</div>
        </q-card-section>

        <q-card-section>
          <!--<FTS></FTS>-->
        </q-card-section>

        <q-card-actions align="right">
          <q-btn label="Cancel" v-close-popup />
          <q-btn label="Complete" color="primary" @click="AddtoCart('Sell')" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<style>

@media screen and (min-width: 600px) {
  .fieldStyle{
    border: 1px solid #e0e0e0; border-radius: 0.5rem; padding: 8px 12px; height: 100%;
  }
}

/* .gridItem{
  height: 100%; margin-bottom: 0px; box-shadow: none; background: #fff;
}

@media screen and (max-width: 768px) {
  .gridItem{
    border-radius: 0rem !important;
    border: none !important;
    padding: 0px !important;
    padding-bottom: 16px !important;
    border-bottom: 1px solid #e0e0e0 !important;
  }
}

@media screen and (min-width: 769px) {
  .gridItem{
    border: 1px solid #e0e0e0; 
    border-radius: 0.5rem;
  }
} */

</style>

<script>
import store from '../store'
import { mapState, mapActions, mapGetters } from "vuex";
import FTB from "./FundTransactionBuy";
import FTBNew from "./FundTransactionNewFund";
import FTS from "./FundTransactionRedemption";
import FTSprs from "./FundTransactionRedemptionPRS";
import FTSW from "./FundTransactionSwitching";
//import FIInfo from './FundInvestmentInfo';
import FIInfo from './FundInvestmentInfoPrototype';
import CB from "@/components/CartButtons";
import BR from "@/components/BasisRecommendation";

export default {
  name: "ShoppingCart",
  components: {
    FTB,
    FTBNew,
    FTS,
    FTSprs,
    FTSW,
    FIInfo,
    CB,
    BR
  },
  data() {
    return {
      TopupModal: false,
      SellModal: false,
      StoreStateCD : store.state.CD,
      StoreStateT : store.state.Transactions,
      StoreStateLookup : store.state.Lookup,
      StoreStateLogin: store.state.Login,
    }
  },
  computed: {
    ...mapState({
      Investment: state => state.CD.Transaction.Investment,
      Redemption: state => state.CD.Transaction.Redemption,
      Switching: state => state.CD.Transaction.Switching,
      CustomerDetail: state => state.CD.Account
    }),
    ...mapGetters([
      "isInvestment",
      "isRedemption",
      "isSwitching",
      "GetSchemeRedeemCutoffTime"
    ]),
  },
   filters: {
		thousandSeparator: function(value) {
			if (value !== undefined) {
				return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			} else {
				return value;
			}
		}
  },
  mounted() {
  },
  methods: {
    ...mapActions([
      "Delete_Investment",
      "Delete_Redemption",
      "Delete_Switching",
      "PostTransaction"
    ]),
    TopupFund() {
      this.TopupModal = true;
    },
    SellFund() {
      this.SellModal = true;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatts(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    AddtoCart(Tr) {
      // do something, add to cart
      var Trans = Tr;
      if (Trans === "Buy") {
        this.TopupModal = false;
      } else if (Trans === "Sell") {
        this.SellModal = false;
      }
    },
    RemoveInvestment(Id){
      this.Delete_Investment(Id)
    },
    RemoveRedemption(Id,count){
        var Scheme = this.StoreStateCD.Transaction.Redemption.find(x=>x.Id === Id).FundID
        var Units = this.StoreStateCD.Transaction.Redemption.find(x=>x.Id === Id).Units
        for(var j=0; j<this.StoreStateCD.Holdings.length; j++){
            if(this.StoreStateCD.Holdings[j].Scheme==Scheme ){
                // var tempAmount =""
                // tempAmount=SelItem.Form.Units.replace(",","");
                // //console.log('1 - >' + tempAmount)
                // tempAmount=tempAmount.replace(",","");
                // // console.log('2 - >' +tempAmount )
                // tempAmount= tempAmount.trim() 
                // //console.log('3 - >' +tempAmount )
                // parseFloat(tempAmount).toFixed(2)
                // //console.log('4 - >' + tempAmount)
                
                   
                if(this.StoreStateCD.Holdings[j].BalanceUnit === "0.00"){
                  this.StoreStateCD.Holdings[j].BalanceUnit = Units
                }else{
                  var temp = this.StoreStateCD.Holdings[j].BalanceUnit
                  //.replace(",","")
                  temp = temp
                  //.replace(",","")
                  temp = parseFloat(temp)
                  this.StoreStateCD.Holdings[j].BalanceUnit = temp + Units // update value balance unit
                  this.StoreStateCD.Holdings[j].BalanceUnit = this.StoreStateCD.Holdings[j].BalanceUnit.toFixed(2)
      
                }


              // this.Delete_Redemption(Id)
            }
        }


      if(this.StoreStateCD.Transaction.Redemption.length>0){
          this.$q.loading.show({
              spinnerSize: 50
          })

        for(var j=0; j<this.StoreStateCD.Transaction.Redemption.length; j++){
          if(this.StoreStateCD.Transaction.Redemption[j].count === count ){
            this.StoreStateCD.Transaction.Redemption.splice(j,1)
          }
        }        

        this.PostTransaction({
          ApplicationId : this.StoreStateCD.FormDetails.ApplicationId
        })
        .then(res=>{

          this.$store.dispatch('Logging',
          {
              typeid :'4', 
              appid : '2', 
              str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' PostTransaction : DELETE item from CART (redeem)-> ' + this.StoreStateCD.FormDetails.ApplicationId + '. res --> ' + res
          });
          if(res!=true){
              this.$q.loading.hide()
              this.$q.dialog({
                  title: 'Error',
                  message:  res ,
              })    
          }
          else{
            this.$q.loading.hide()
          }
        })        
      }  

    },
    RemoveSwitching(Id){
      this.Delete_Switching(Id)
    }
  }
};
</script>